"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, useCallback } from "react";
import { useIntersectionObserver } from "usehooks-ts";
import type { FloatingNavItem } from "./floating-nav.types";
export function useFloatingNav(items) {
  const $ = _c(11);
  const [pastSentinel, setPastSentinel] = useState(false);
  const [nearFooter, setNearFooter] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [activeId, setActiveId] = useState(items[0]?.targetId ?? null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      threshold: 0,
      onChange: (isIntersecting, entry) => {
        if (isIntersecting) {
          setPastSentinel(true);
        } else {
          if (entry.boundingClientRect.top > 0) {
            setPastSentinel(false);
          }
        }
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    ref: sentinelRef
  } = useIntersectionObserver(t0);
  const isVisible = pastSentinel && !nearFooter;
  let t1;
  let t2;
  if ($[1] !== items) {
    t1 = () => {
      if (!items || items.length === 0) {
        return;
      }
      const onScroll = () => {
        const header = document.querySelector("header");
        const offset = (header?.getBoundingClientRect().height ?? 0) + 1;
        let found = false;
        for (let i = items.length - 1; i >= 0; i--) {
          const el = document.getElementById(items[i].targetId);
          if (el) {
            const rect = el.getBoundingClientRect();
            if (rect.top <= offset) {
              setActiveId(items[i].targetId);
              found = true;
              break;
            }
          }
        }
        if (!found) {
          setActiveId(items[0]?.targetId ?? null);
        }
        const footer = document.querySelector("footer");
        const footerHeight = footer?.offsetHeight ?? 0;
        const scrollBottom = window.scrollY + window.innerHeight;
        const docHeight = document.documentElement.scrollHeight;
        setNearFooter(footerHeight > 0 ? docHeight - scrollBottom < footerHeight : false);
      };
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      onScroll();
      return () => window.removeEventListener("scroll", onScroll);
    };
    t2 = [items];
    $[1] = items;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = targetId => {
      const element = document.getElementById(targetId);
      if (element) {
        const header_0 = document.querySelector("header");
        const headerOffset = header_0?.getBoundingClientRect().height ?? 0;
        const top = element.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({
          top,
          behavior: "smooth"
        });
      }
      setIsOpen(false);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleNavClick = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsOpen(_temp);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleToggle = t4;
  const handleScrollToTop = _temp2;
  let t5;
  if ($[6] !== activeId || $[7] !== isOpen || $[8] !== isVisible || $[9] !== sentinelRef) {
    t5 = {
      sentinelRef,
      isVisible,
      isOpen,
      activeId,
      handleNavClick,
      handleToggle,
      handleScrollToTop
    };
    $[6] = activeId;
    $[7] = isOpen;
    $[8] = isVisible;
    $[9] = sentinelRef;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp2() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
function _temp(prev) {
  return !prev;
}